export var VERSION = '2.23.4';
//# sourceMappingURL=version.js.map